import GenerateV2PDFModal from './generate-v2-pdf-modal';

export default GenerateV2PDFModal;
